module.exports = __webpack_public_path__ + "static/img/gd-11.90c5a583.jpg";